<template>
  <div class="editor-quote__edit-wrapper">
    <EditorEditButton
      v-show="editing"
      icon="editor/apply"
      @click="emit('save')"
    />
    <EditorEditButton
      v-show="!editing"
      icon="editor/setting"
      @click="emit('edit')"
    />
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
defineProps({
  editing: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['edit', 'save', 'delete']);
</script>
